import { Component } from '@angular/core';
import { Router } from '@angular/router';

/** Standalone-site home: hero + search chrome around the shared <ee-help-home> card grid. */
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent {
  query = '';

  constructor(private router: Router) {}

  openCollection(collection: string): void {
    this.router.navigate(['/collection', collection]);
  }

  onSearch(): void {
    const q = this.query.trim();
    if (q) {
      this.router.navigate(['/search'], { queryParams: { q } });
    }
  }
}
